<template>
    <div>
        <div class="c-tr gap-1 flex-wrap">
            <div v-if="product.main === false" class="c-td">
                <span v-text="`EAN: ${product.ean}`" />
            </div>
            <div v-else class="c-td">
                <p class="mb-0">
                    <strong v-text="product.name" />
                </p>
                <span v-if="product.ean" v-text="`EAN: ${product.ean}`" />
            </div>

            <!-- Local code col -->
            <div
                v-if="product.eanPresent === false && product.main"
                class="c-td"
            >
                <span v-text="'Kod lokalny'" class="typo-label d-block d-md-none" />
                <the-input
                    class="mb-0 w-100"
                    validation="localCode"
                    invalid-feedback="Kod musi być unikalny"
                    :disabled="!isEditablePromo"
                    :invalid="
                        errors.findIndex(
                            el => el.id === product.id && el.type === 'code'
                        ) > -1
                    "
                    :text="product.alternative_ean"
                    @input="changeLocalCode(product, $event)"
                    @change="checkIfEanExists(product, $event.target.value)"
                />
            </div>

            <!-- Promo price col -->
            <div v-if="userCanEdit && product.main" class="c-td">
                <span
                    v-text="'Cena w promocji'"
                    class="typo-label d-block d-md-none"
                />
                <money-input
                    class="mb-0"
                    :key="`p-${product.id}`"
                    :price="product.price"
                    :max-value="+product.max_price"
                    :disabled="false"
                    :invalid="!!invalidFeedbackPrice"
                    :invalid-feedback="invalidFeedbackPrice"
                    @onInput="changeProductPrice(product, $event)"
                />
            </div>
            <div
                v-else-if="promoType === PROMO_TYPES.QUOTA && product.main"
                class="c-td"
            >
                <span class="typo-label d-block d-md-none">
                    Rabat brutto
                    <a-icon
                        v-tooltip="'Rabat brutto do zestawu'"
                        width="16"
                        height="16"
                        icon="Info"
                    />
                </span>

                {{ -product.discount_amount | currency }}
            </div>
            <div class="c-td" v-else-if="product.main">
                <span
                    v-text="'Cena zestawu'"
                    class="typo-label d-block d-md-none"
                />

                {{ product.price | currency(promoType) }}
            </div>

            <div
                v-if="product.eanErrors && product.eanErrors.length > 0"
                class="w-100 d-flex"
            >
                <alt-ean-warning
                    class="ml-auto"
                    :alt-ean-error="
                        product.eanErrors.filter(
                            el => el.ean !== dict.ean
                        )[0]
                    "
                />
            </div>
            <slot name="showMoreBtn" />
        </div>
        <slot />
    </div>
</template>

<script>
import AltEanWarning from '@/components/promotions/altEans/AltEanWarning.vue'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        merchantId: {
            type: Number,
            required: false
        },
        promotion: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            PROMO_TYPES
        }
    },

    components: {
        AltEanWarning
    },
    computed: {
        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },
        isEditablePromo() {
            return this.$store.getters.isEditablePromo(this.promoType)
        },
        userCanEdit() {
            return this.isEditablePromo && this.isPromoEditPermission
        },
        promoType() {
            return this.promotion.type
        },
        subscription() {
            return this.promotion.subscriptions.find(
                sub => sub.merchant_id === this.merchantId
            ) || {}
        },
        // subscription() {
        //     return this.$store.getters.getSubscriptionByMerchantId(
        //         this.merchantId
        //     )
        // },
        errors() {
            return this.$store.getters.getSubscriptionLocalCodeErrors
        },
        invalidFeedbackPrice() {
            const maxPrice = +this.product.max_price
            return +this.product.price > maxPrice
                ? `Wartość maksymalna: ${this.$options.filters.currency(maxPrice)}`
                : undefined
        },
        promoGroups() {
            return this.$store.getters.getPromo
        }
    },
    methods: {
        async checkIfEanExists(product, localCode) {
            if (!this.$store.getters.isProductEansPermission) return

            const vue = this

            if (!localCode) {
                this.subscription.product_subscriptions.forEach(p => {
                    if (p.id === product.id) {
                        vue.$set(p, 'eanErrors', undefined)
                    }
                })
                return
            }

            const res = await this.$store.dispatch('checkIfEansExist', [
                {
                    alternative_ean: localCode,
                    merchant_id: this.merchantId
                }
            ])

            this.subscription.product_subscriptions.forEach(p => {
                if (p.id === product.id) {
                    vue.$set(p, 'eanErrors', res)
                }
            })
        },
        changeLocalCode(product, alternative_ean) {
            const subProductIds = (product.subProducts || []).map(el => el.id)

            this.subscription.product_subscriptions.forEach(p => {
                if (p.promo_dict_product_id === product.promo_dict_product_id || subProductIds.includes(p.id)) {
                    p.alternative_ean = alternative_ean
                }
            })
        },
        changeProductPrice(product, price) {
            const subProductIds = (product.subProducts || []).map(el => el.id)

            this.subscription.product_subscriptions.forEach(p => {
                if (p.promo_dict_product_id === product.promo_dict_product_id || subProductIds.includes(p.id)) {
                    p.price = price
                }
            })
        }
    }
}
</script>
